const closet = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1_33242)">
      <path d="M21.6003 18.2L13.0003 11.75V10.84C14.6503 10.35 15.8003 8.66997 15.4303 6.78997C15.1703 5.47997 14.1303 4.38997 12.8203 4.08997C10.5403 3.56997 8.50026 5.29997 8.50026 7.49997H10.5003C10.5003 6.66997 11.1703 5.99997 12.0003 5.99997C12.8303 5.99997 13.5003 6.66997 13.5003 7.49997C13.5003 8.33997 12.8103 9.01997 11.9703 8.99997C11.4303 8.98997 11.0003 9.44997 11.0003 9.98997V11.75L2.40026 18.2C1.63026 18.78 2.04026 20 3.00026 20H12.0003H21.0003C21.9603 20 22.3703 18.78 21.6003 18.2ZM6.00026 18L12.0003 13.5L18.0003 18H6.00026Z" fill="black" />
    </g>
    <defs>
      <clipPath id="clip0_1_33242">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);
export default closet;
